import { Component, OnInit, ViewContainerRef, ViewChildren, QueryList, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GridsterConfig, GridsterItem, GridsterItemComponentInterface } from "angular-gridster2";
import { DashboardModel, DashboardContentModel } from "./models/dashboard.model";
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { DashboardService } from "../dash-board/services/dashboard.service";

@Component({
    selector: 'app-dashboard-master',
    templateUrl: './dashboard-master.component.html',
    styleUrls: ['./dashboard-master.component.scss'],
    standalone: false
})
export class DashboardMasterComponent implements OnInit, OnDestroy {
	roles: any;
	selectedRole: any = 1;
	widgetCollection: any;
	config: any = {};
	constructor(private _route: ActivatedRoute,
		private baseService: BaseService,
		private alerts: AlertsService,
		private loader: LoaderService,
		public dashBoardService:DashboardService) { }


	public options: GridsterConfig;
	public dashboardCollection: DashboardModel;
	public dashboardArray: any[] = [];
	@ViewChildren('customComponent', { read: ViewContainerRef }) customComponent: QueryList<ViewContainerRef>;

	ngOnInit() {
		this.dashboardArray = []
		// this.communicationService.emitSidebar({ sidebar: false });
		this.options = this.dashBoardService.getGridsterOption();
		this.options.itemChangeCallback = ()=>{
			this.addRowNumbers();
		}
		this.options.emptyCellDropCallback = (evt)=>{
			this.onDrop(evt);
		};
		this.baseService.get('GET_ALL_WIDGET', 'page:false,all:true', 'widget_config', 'account-management').subscribe(widgets => {
			widgets.resource.sort((a, b) => a.widget_name > b.widget_name ? 1 : -1)
			this.widgetCollection = widgets.resource;
			if(Array.isArray(this.widgetCollection) && this.widgetCollection.length>0){
				for (let index = 0; index < this.widgetCollection.length; index++) {
					var widget = this.widgetCollection[index];
					this.categorizeWidgets(widget);
				}
				console.log("this.config====>",this.config);
			}
		});
		document.addEventListener('drag',this.scrollWindow)
		this.getData();
	}
	setComponet() {
		this.customComponent.toArray().forEach(entry => {
			entry.clear()
		})
		this.dashboardArray.forEach((item: any, index) => {
			this.setSingleComponet(index);
		})
	}

	getData() {
		this.dashboardArray = []
		// We get the id in get current router dashboard/:id
		if (this._route.snapshot.params.id) {
			this.baseService.getById(this._route.snapshot.params.id, 'dashboard_master_list', 'account-management').subscribe(res => {
				if (res.dashboard == ''){
					res.dashboard = []
				}else{
					res.dashboard = JSON.parse(res.dashboard);
				}
				this.dashboardCollection = res;
				this.dashboardArray = this.dashboardCollection.dashboard.slice();
				setTimeout(() => { this.setComponet(); })
			})
		}

	}

	itemChange(index) {
		this.dashboardCollection.dashboard = this.dashboardArray;
		let tmp = JSON.stringify(this.dashboardCollection);
		let parsed: DashboardModel = JSON.parse(tmp);
		setTimeout(() => { 
			this.customComponent.toArray()[index].clear();
			this.setSingleComponet(index); 
		})
	}

	categorizeWidgets(widget){
		var widgetType= widget.selector;
		if(this.config[widgetType] == undefined && widgetType){
			var obj = this.widgetCollection.slice().filter(elem => (elem.selector == widgetType));
			
			if(obj.length > 0){
				this.config[widgetType] = obj;
			}else{
				this.config[widgetType] = [];
			}
		}	
	}
	onDrop(ev) {
		if(this.dashboardArray != undefined){
			var widget = JSON.parse(ev.dataTransfer.getData("widget"));
			widget = this.dashBoardService.prepreateWidgetData(widget);
			this.dashboardArray.push(widget);
			this.itemChange(this.dashboardArray.length-1);
		}
	}

	setWidget(item, event,index) {
		var found = false;
		let widg = this.widgetCollection.find(elem => (elem.id == event.target.value));
		if(widg != undefined) {
			found = this.dashboardArray.find(elem => (elem.widget_id == widg.id));
		}
		
		if( found || (widg==undefined) ) {
			var widgetType = item.widget_type;
			var selector = item.selector;
			event.target.value = "";
			if(widg!=undefined){
				this.alerts.error("Selected widget already exists.");
			}
			
			this.dashboardArray[index] = {widget_type:widgetType,cols:4,rows:4,selector:selector};
		}else{
			item.widget_id = widg.id
			this.dashboardArray[index].widget_id = item.widget_id;
			item.selector = widg.selector;
			if(this.dashboardArray[index] != undefined){
				this.dashboardArray[index].id = widg.id;
			}
			var newWidgTemp = this.dashBoardService.prepreateWidgetData(widg);
			var newWidg:any = {};
			newWidg.widg_selector = newWidgTemp.selector
			newWidg.cols = item.cols;
			newWidg.rows = item.rows;
			newWidg.widget_id = item.widget_id;
			this.dashboardArray[index] = newWidg;
			this.itemChange(index)
		}
		
	}

	changedOptions() {
		this.options.api.optionsChanged();
	}

	removeItem(index) {
		this.customComponent.toArray()[index].clear()
		if (this.dashboardArray.length == 1){
			this.dashboardArray = []
		}else{
			this.dashboardArray.splice(index,1);
		}
			
		this.dashboardCollection.dashboard = this.dashboardArray;
	}

	updateDash() {
		this.loader.showSpinner()
		this.dashboardCollection.dashboard = this.dashboardArray;
		let tmp = JSON.stringify(this.dashboardCollection);
		let parsed: DashboardModel = JSON.parse(tmp);
		if (this._route.snapshot.params.id) {
			let obj = { id: this._route.snapshot.params.id, dashboard: JSON.stringify(this.dashboardArray) }
			this.baseService.action(obj, 'MODIFY', 'account-management', 'dashboard_master_list').subscribe(res => {
				console.log(res)
				setTimeout(() => {
					this.loader.hideSpinner()
					this.alerts.info('Saved Successfully')
				})

			})

		}
	}
	setSingleComponet(index) {		
		var selector = this.dashboardArray[index]['widg_selector'] || this.dashboardArray[index]['selector'];
		if(selector){
			this.createComponent(selector,index);
		}
	}

	createComponent(selector,index){
		this.baseService.createComponent(selector, this.customComponent.toArray()[index], (response) => {
			response.instance.data = this.dashboardArray[index];
			response.instance.hideLabels = true;
			response.changeDetectorRef.detectChanges();
		});
	}
	getWidgetCollection(item) {
		return this.widgetCollection.slice().filter(elem => (elem.widget_type == item.widget_type || elem.name == item.widgetType))
	}
	
	scrollWindow(e){
		
			if(e.clientY>=window.innerHeight-40){
			window.scrollBy({
			  top: 20,
			  behavior: 'smooth'
			});
			}
			if(e.clientY<=70){
			window.scrollBy({
			  top: -20,
			  behavior: 'smooth'
			});
			}
			
	}

	addRowNumbers() {
		const rows = document.querySelectorAll('.gridster-row');
		rows.forEach((row, index) => {
			// Check if the row already has a serial number div
			if (!row.querySelector('.serial-number')) {
				const serialNumber = document.createElement('div');
				serialNumber.className = 'serial-number';
				serialNumber.textContent = `Row ${index + 1}`;
				row.prepend(serialNumber);
			}
		});
	}
	ngAfterViewInit(){
		this.addRowNumbers();
	}
	ngOnDestroy(){
		document.removeEventListener('drag',this.scrollWindow)
	}
}
